import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Settings } from '../model/settings.model';
import { SettingsService } from '../service/settings.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {
  resultTable: Settings[] = null;
  msgs: any[] = [];

  constructor(private settingsService: SettingsService, private router: Router) { }
  ngOnInit() {
    this.getSettingsList();
  }

  getSettingsList(): any {
    this.settingsService.getSettingsList().subscribe((result: Settings[]) => {
      this.resultTable = result;
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בקבלת רשימת הגדרות ');
      });
  }

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }


  settingsSet(settings: Settings): void {
      let ok = confirm(`האם ברצונך לעדכן את הערך של ההגדרה ${settings.Key} ?`);
      if (ok) {
        this.settingsService.settingsSet(settings).subscribe((result: any) => {
        this.showMessage('success', '', 'עדכון בוצע בהצלחה');
        this.getSettingsList();
        }, (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה בעדכון');
        });
      }
   
  }
}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/settings/settings.component.ts